import { render, staticRenderFns } from "./ViewBillingChangeRequests.vue?vue&type=template&id=84c71d9a"
import script from "./ViewBillingChangeRequests.vue?vue&type=script&lang=ts"
export * from "./ViewBillingChangeRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports